<template>
<div class="withdraw">
	<van-nav-bar :title="$t('withdraw.title')" left-text="" @click-left="back()" left-arrow >
	  <template #right>
	    <span style="color: rgb(255, 255, 255);font-size: 0.75rem;"  @click="$router.push({path:'/WithdrawRecord'});">
	    	{{$t('withdraw.log')}}
	    </span>
	  </template>
	</van-nav-bar>
	<div class="top">
		<div>
			<van-image round width="4.2rem" height="4.2rem" :src="userInfo.header_img" >
				<template v-slot:loading>
				    <van-loading type="spinner"/>
				</template>
			</van-image>
			<div class="info">
				<p>{{userInfo.username}}</p>
				<p>{{$t('infomation.amount')}}：$ {{userInfo.money}} </p>
			</div>
		</div>
	</div>
	<div class="kfsm">
		<img src="/img/kf.png" alt="">
		<p>{{$t('withdraw.withdrawClosedNotice')}}</p>
	</div>
	<div class="kf">
		<van-button type="success" round block size="large" @click="toService">{{$t('withdraw.contactReception')}}</van-button>
	</div>
</div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    toService(){
      if(this.$store.getters.getBaseInfo.iskefu == 1){
        this.$router.push("ServiceOnline");
      }else {
        this.$toast.fail(this.$t('common.noallow'));
      }
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style scoped>
:export {
    gbcolor: linear-gradient(30deg,#7d76ef,#d63f8c)
}

.van-hairline--bottom:after {
    border-bottom-width: 0
}

.van-nav-bar {
    position: absolute;
    width: 100%
}

.withdraw {
    width: 100%;
    height: 100%;
    background: #fff
}

.withdraw .top {
    width: 100%;
   background: linear-gradient(41deg,#7d76ef,#e3549d 90%);
    padding: 4rem 5% 1.33333rem
}

.withdraw .top>div {
    display: flex;
    justify-content: flex-start;
    align-items: center
}

.withdraw .top .van-image {
    border: 4px solid #fff
}

.withdraw .top>div .info {
    text-align: left;
    color: #fff;
    padding-left: 1rem
}

.withdraw .top>div .info>p {
    padding: .33333rem 0
}

.withdraw .kfsm {
    width: 94%;
    margin: 1.33333rem auto 0;
    display: flex;
    background: #f2f2f5;
    padding: 1.33333rem;
    border-radius: 6.66667rem
}

.withdraw .kfsm p {
    text-align: justify;
    padding-left: .66667rem;
    font-size: .83333rem;
    color: #390f86
}

.withdraw .kfsm img {
    width: 3rem
}

.withdraw .kf {
    margin-top: 3.33333rem
}

.withdraw .kf .van-button--block {
    width: 60%;
    margin: 0 auto;
    height: 2.8rem;
    font-size: 1rem;
    color: #fff;
    background: linear-gradient(30deg,#9b54ca,#e6557f);
    border: none
}
</style>
